<div class="dialog-box">
    <div class="success-box">
        <div class="success-tick-box">
            <div class="success-tick-box-l1">
                <div class="success-tick"></div>
            </div>
        </div>

        <div class="success-message">Receiving data inserted successfully!</div>

        <div class="success-message-secondary">Reference Number: {{data.message}}</div>

        <div class="text-secondary">You can print or close the message.</div>


        <button (click)="printContent()">Print</button>
        <button (click)="closeDialog()">Close</button>

    </div>
</div>